// DevHub UI kit — empty state block.
//
// The "nothing here / no results" placeholder every section re-invents. Optional
// title and message; defaults are i18n'd.
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { kitMessages } from '../../../i18n/kit';
import './states.css';

export interface EmptyStateProps {
  /** Heading (defaults to "Nothing to show"). */
  title?: string;
  /** Body text (defaults to "There is nothing here yet."). */
  message?: string;
}

export const EmptyState = ({ title, message }: EmptyStateProps) => {
  const { t } = useTranslationRef(kitMessages);
  return (
    <div className="devhub-state devhub-state--empty">
      <odx-empty-state icon="core::info" alignment="center">
        {title ?? t('states.emptyTitle')}
        <span slot="hint">{message ?? t('states.emptyBody')}</span>
      </odx-empty-state>
    </div>
  );
};
